import React, { useState } from "react";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import { Form } from "react-bootstrap";
import "./Create_Account_Step5.css"

const Create_Account_Step5 = ({ setStep }) => {
  const [selected, setSelected] = useState("Weight Gain");

  const goals = [
    "Weight Loss",
    "Weight Gain",
    "Muscle Mass Gain",
    "Shape Body",
    "Other (Please Specify)",
  ];
  return (
    <section className="step1_wrapper step3_wrapper step5_wrapper">
      <Form_Header step={5} totalSteps={6} />
      <div className="weight_selection_div business_constitution_div">
        <h2 className="select_title">Select Business Constitution</h2>
        <div className="goal_wrapper">
          <Form>
            {goals.map((goal) => (
              <div
                key={goal}
                className={`goal_item ${selected === goal ? "active" : ""}`}
                onClick={() => setSelected(goal)}
              >
                <span className="goal_text">{goal}</span>

                <Form.Check
                  type="radio"
                  name="goal"
                  checked={selected === goal}
                  readOnly
                />
              </div>
            ))}
          </Form>
        </div>
        <div className="form_btn_holder">
          <White_Btn btnText="Back" onClick={() => setStep(4)} />
          <Common_Btn btnText="Next" onClick={() => setStep(6)} />
        </div>
      </div>
    </section>
  );
};

export default Create_Account_Step5;
